import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
/**
 * NOTE: Nothing in this file can be accessed from outside the package unless it
 * it also exported in index.tsx
 */

export var CellContext = /*#__PURE__*/React.createContext({});
export var CardContext = /*#__PURE__*/React.createContext({});
export var AddonContext = /*#__PURE__*/React.createContext({
  inAddon: false
});
var formatters = {
  pounds: function pounds(value) {
    return value % 1 === 0 ? "\xA3".concat(value) : "\xA3".concat(Number(value).toFixed(2));
  },
  // Alternative version of the pounds formatter that takes care of adding 0 as needed
  'full-pounds': function fullPounds(value) {
    return "\xA3".concat(value.toFixed(2));
  },
  'pounds-with-commas': function poundsWithCommas(value) {
    return Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(value);
  },
  percent: function percent(value) {
    return "".concat(value, "%");
  },

  /**
   * The simplicity of this funciton will need addressing in the future, however Kb, Mb, and Gb are
   * all proven on the Uswitch site.
   */
  'data-transfer': function dataTransfer() {
    var kilobits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (kilobits < 1000) return "".concat(kilobits || 0, "Kb");
    if (kilobits >= 1e6) return "".concat(Math.floor(kilobits / 1e6), "Gb");
    return "".concat(Math.floor(kilobits / 1000), "Mb");
  },

  /**
   * The simplicity of this funciton will need addressing in the future, however MB and GB are all
   * proven on the Uswitch site.
   */
  data: function data() {
    var megabytes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (megabytes >= 1000) return "".concat(Math.floor(megabytes / 1000), "GB");
    return "".concat(megabytes || 0, "MB");
  },
  'exchange-rate': function exchangeRate(value) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
    var regex = new RegExp("^-?\\d+(?:\\.\\d{0,".concat(count, "})?"));
    var matches = value.toString().match(regex);
    var withDecimals = matches !== null && matches !== void 0 && matches.length ? matches[0] : '';

    var _withDecimals$split = withDecimals.split('.'),
        _withDecimals$split2 = _slicedToArray(_withDecimals$split, 2),
        _withDecimals$split2$ = _withDecimals$split2[0],
        before = _withDecimals$split2$ === void 0 ? '' : _withDecimals$split2$,
        _withDecimals$split2$2 = _withDecimals$split2[1],
        after = _withDecimals$split2$2 === void 0 ? '' : _withDecimals$split2$2;

    var val = "".concat(before, ".").concat(after.padEnd(count, '0'));
    return val;
  }
}; // Should be fleshed out and moved into a util package

export function numberFormatter(value, unit) {
  if (typeof value === 'string') {
    return value;
  }

  var unitValue = unit || '';
  var formatter = unitValue.split(' ').join('-');
  return formatters[formatter] ? formatters[formatter](value) : "".concat(value, " ").concat(unitValue).trim();
}
export var forceMobile = function forceMobile() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (styles) {
    if (!force) return styles;
    return styles[0];
  };
};
//# sourceMappingURL=generics.js.map